/** The values are taken from the openapi, see cancelSubscription payload */

/**
 * @Deprecated Avoid using this; prefer the new CancellationReasonEnum whenever possible.
 * Currently used only in apps\passenger\src\view\organisms\DTicketCancellationFlow\ReasonFormStep.tsx
 * for rendering cancellation reasons properly.
 */
export enum DEPRECATED_EDTicketCancellationReasons {
	SubscriptionPriceIncrease = 'SUBSCRIPTION_PRICE_INCREASE',
	NoSubscriptionNeeded = 'NOT_NEEDED_ANYMORE',
	CantAfford = 'CANT_AFFORD',
	EmployerProvidedTicket = 'RECEIVING_THROUGH_EMPLOYER',
	UnawareOfSubscription = 'UNAWARE_OF_SUBSCRIPTION',
	UnhappyWithService = 'NOT_SATISFIED',
	BetterOfferElsewhere = 'RECEIVING_CHEAPER',
	OtherReason = 'OTHER_REASON',
}
